import { useState, useContext } from 'react';
import './AvatarMenu.css';
import { CurrentUserContext } from '../../../Contexts/CurrentUserContext';
import api from '../../../Utils/Api';

const AvatarMenu = ({ openPhoto, onClose, changePhoto, setAvatar }) => {
    const { token, setUser, user } = useContext(CurrentUserContext);

    const deleteAvatar = () => {
        api.deleteAvatar(token)
            .then((res) => {
              //  console.log(res)
                setAvatar(undefined)
                setUser({ ...user, avatar: undefined })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    return (
        <div className='avatarMenu__container'>
            <div className='avatarMenu__option avatarMenu__option_open' onClick={() => { openPhoto(true); onClose(false) }}>Открыть фото</div>
            <div className='avatarMenu__option avatarMenu__option_change' onClick={() => { onClose(false); changePhoto(true) }}>Изменить фото</div>
            <div className='avatarMenu__option avatarMenu__option_delete' onClick={() => { onClose(false); deleteAvatar() }}>Удалить фото</div>
        </div>
    )
}
export default AvatarMenu
